import React from 'react';
import SideBarContainer from 'Containers/SideBarContainer';
import FilterContainer from 'Containers/FilterContainer';
import Title from 'Components/Title';
import useMyCoursesPage from './hooks/useMyCoursesPage';
import FiltersBar from './components/molecules/FiltersBar/FiltersBar';
import CoursesCardGrid from './components/organisms/CoursesCardGrid/CoursesCardGrid';
import CoursesTable from './components/organisms/CoursesTable/CoursesTable';
import { CourseSection, ErrorState, RetryButton, SectionTitle } from './MyCourses.styled';

export default function MyCourses() {
  const {
    t2,
    loading,
    error,
    retry,
    courses,
    cardSections,
    categories,
    colorCategory,
    isCard,
    setIsCard,
    setName,
    setCategory,
    setStatusName,
    statusOptions,
    goToCourseDetails,
  } = useMyCoursesPage();

  let content;
  if (error) {
    content = (
      <ErrorState>
        {t2('LoadError')}
        <RetryButton type="button" onClick={retry}>
          {t2('Retry')}
        </RetryButton>
      </ErrorState>
    );
  } else if (isCard && cardSections.length === 0) {
    // Sin secciones no hay nada que encabezar: un solo vacío (o el loading).
    content = <CoursesCardGrid items={[]} loading={loading} emptyText={t2('NoData')} onCourseClick={goToCourseDetails} />;
  } else if (isCard) {
    content = cardSections.map(section => (
      <CourseSection key={section.key} data-testid="course-section" data-section={section.key}>
        {/* El título comparte FilterContainer con la rejilla: así hereda su misma
            geometría (ancho y centrado) en vez de replicarla, y su padding-left
            (GRID_INSET, el mismo de ListMyCourses) lo alinea con las cards. */}
        <FilterContainer>
          <SectionTitle data-testid="course-section-title">{section.title}</SectionTitle>
        </FilterContainer>
        <CoursesCardGrid
          items={section.items}
          loading={false}
          emptyText={t2('NoData')}
          onCourseClick={goToCourseDetails}
        />
      </CourseSection>
    ));
  } else {
    content = (
      <CoursesTable
        courses={courses}
        colorCategory={colorCategory}
        headers={
          [t2('TableTitle'), t2('Description'), t2('Priority'), t2('Category'), t2('CreatedBy')] as string[]
        }
        loading={loading}
        onCourseClick={goToCourseDetails}
      />
    );
  }

  return (
    <SideBarContainer>
      <Title title={t2('Title')} />
      <FiltersBar
        searchPlaceholder={t2('Search') as string}
        categoryTitle={t2('Category') as string}
        statusTitle={t2('Status') as string}
        categories={categories}
        statusOptions={statusOptions}
        isCard={isCard}
        onNameChange={setName}
        onCategoryChange={setCategory}
        onStatusChange={setStatusName}
        onToggleView={setIsCard}
      />
      {content}
    </SideBarContainer>
  );
}
